import { toast } from 'react-toastify'
import { TABLA_CEREALES } from '../../../config/tables'
import Biotecnologia from '../../../models/biotecnologia'
import Cereal from '../../../models/cereal/cereal'
import CerealVariedad from '../../../models/cereal/cereal_variedad'
import { COL_CEREALES } from './constantes'
import { getFormValues } from 'redux-form'
import { FORM_CEREALES } from '../../../config/forms'

const cereal = new Cereal()

export function parseData (data) {
  const parsedData = []
  data.forEach(entry => {
    parsedData.push({ ...entry, entry: entry })
  })
  return parsedData
}

export function requestBiotecnologiasByCereal (cereal = null) {
  return (dispatch, getState) => {
    const state = getState()
    const {
      selectedCerealEspecie
    } = state.cereal

    cereal = cereal || selectedCerealEspecie
    dispatch({ type: 'REQUEST_BIOTECNOLOGIAS' })
    return Biotecnologia.getBiotecnologiasByCereal(cereal)
      .then(biotecnologias => {
        dispatch({
          type: 'RECEIVE_BIOTECNOLOGIAS',
          biotecnologias })
      })
      .catch(_ => dispatch({
        type: 'RECEIVE_BIOTECNOLOGIAS',
        biotecnologias: []
      }))
  }
};

export function setBiotecnologia (biotecnologia) {
  return dispatch => {
    dispatch({ type: 'SET_BIOTECNOLOGIA', biotecnologia })
  }
};

export function requestCerealEspecie (claveCereal, callback = null) {
  return async dispatch => {
    dispatch({ type: 'REQUEST_CEREAL_ESPECIE' })
    return Cereal.getDatosCereal(await claveCereal)
      .then(cerealEspecie => {
        dispatch({
          type: 'RECEIVE_CEREAL_ESPECIE',
          cerealEspecie })
        callback && callback(cerealEspecie)
      })
      .catch(_ => dispatch({
        type: 'RECEIVE_CEREAL_ESPECIE',
        cerealEspecie: null
      }))
  }
};

export function requestCerealEspecies () {
  return dispatch => {
    dispatch({ type: 'REQUEST_CEREAL_ESPECIES' })
    return Cereal.getCereales()
      .then(cerealEspecies => {
        dispatch({
          type: 'RECEIVE_CEREAL_ESPECIES',
          cerealEspecies })
        dispatch(getVariedades())
        /* dispatch(setCerealEspecie(cerealEspecies[0].nombreCorto)); */
        // dispatch(setCerealEspecie('UNDEF'));
      })
      .catch(_ => dispatch({
        type: 'RECEIVE_CEREAL_ESPECIES',
        cerealEspecies: []
      }))
  }
};

export function requestCerealEspeciesConDeshabilitados () {
  return dispatch => {
    dispatch({ type: 'REQUEST_CEREAL_ESPECIES' })
    return Cereal.getCerealesConDeshabilitados()
      .then(cerealEspecies => {
        dispatch({
          type: 'RECEIVE_CEREAL_ESPECIES',
          cerealEspecies })
        dispatch(getVariedades())
      })
      .catch(_ => dispatch({
        type: 'RECEIVE_CEREAL_ESPECIES',
        cerealEspecies: []
      }))
  }
};

export function setCerealEspecie (cerealEspecie) {
  return dispatch => {
    dispatch({ type: 'SET_CEREAL_ESPECIE', cerealEspecie })
    dispatch(getVariedades())
    console.log('setCerealEspecie', cerealEspecie)
  }
};

export function getVariedades () {
  return (dispatch, getState) => {
    const state = getState()
    const { cereal: { selectedCerealEspecie } } = state
    dispatch({ type: 'REQUEST_CEREAL_VARIEDADES' })
    return CerealVariedad.getVariedades(selectedCerealEspecie)
      .then(variedades => dispatch({
        type: 'RECEIVE_CEREAL_VARIEDADES',
        cerealVariedades: variedades
      }))
      .catch(_ => dispatch({
        type: 'RECEIVE_CEREAL_VARIEDADES',
        cerealVariedades: []
      }))
  }
}

export function setCerealEspecieConVariedad (cerealEspecie, variedad) {
  return dispatch => {
    dispatch({ type: 'SET_CEREAL_ESPECIE', cerealEspecie })
    dispatch(getVariedad(cerealEspecie, variedad))
  }
};

export function getVariedad (cerealEspecie, variedad) {
  return (dispatch, getState) => {
    dispatch({ type: 'REQUEST_CEREAL_VARIEDAD' })
    return CerealVariedad.getVariedad(cerealEspecie, variedad)
      .then(variedad => dispatch({
        type: 'RECEIVE_CEREAL_VARIEDADES',
        cerealVariedades: variedad
      }))
      .catch(_ => dispatch({
        type: 'RECEIVE_CEREAL_VARIEDADES',
        cerealVariedades: []
      }))
  }
}

export function obtenerCerealesTodos () {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CEREALES
    })

    cereal.getCerealesTodos()
      .then((d) => {
        const data = parseData(d)
        const customToolbar = null
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: COL_CEREALES,
            data: data,
            title: 'Cereales',
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              download: false,
              pagination: false,
              tableBodyMaxHeight: '699px'
            }
          },
          id: TABLA_CEREALES
        })
      })
      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar obtener los datos')
      })
  }
}

export function agregarCereal () {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_CEREALES)(state)
    cereal.addCereal(formValues)
      .then((result) => {
        if (!result.error) {
          toast.success('Cereal agregado correctamente')
          dispatch(obtenerCerealesTodos())
        } else {
          toast.error('Error al intentar agregar el cereal')
        }
      })
      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar agregar el cereal')
      })
  }
}

export function actualizarCereal () {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_CEREALES)(state)
    const nombreCorto = formValues.nombreCorto
    cereal.updateCereal(nombreCorto, formValues)
      .then((result) => {
        if (!result.error) {
          toast.success('Cereal modificado correctamente')
          dispatch(obtenerCerealesTodos())
        } else {
          toast.error('Error al intentar modificar el cereal')
        }
      })
      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar modificar el cereal')
      })
  }
}

export function eliminarCereal (nombreCorto) {
  return async () => {
    try {
      const result = await cereal.deleteCereal(nombreCorto)
      if (!result.error) {
      } else {
        toast.error('Error al intentar eliminar el cereal')
      }
    } catch (error) {
      toast.error('Error al intentar eliminar el cereal')
    }
  }
}
